import { CREATIVE_TYPES } from "../../components/creative/index/constants";
import { AdminCreativesApprovalsPage } from "../../components/creative/index/creative_approval/index_admin";
import MarginCreatePage from "../../components/margin/create";
import MarginEditPage from "../../components/margin/edit";
import { MarginsPage } from "../../components/margin/index";
import ProductCatalogPermissionsCreatePage from "../../components/product-catalog-permissions/create";
import ProductCatalogPermissionsEditPage from "../../components/product-catalog-permissions/edit";
import ProductCatalogPermissionsPage from "../../components/product-catalog-permissions/index";
import UserCreatePage from "../../components/user/create";
import UserEditPage from "../../components/user/edit";
import { UsersPage } from "../../components/user/index";
import { Routes as creativeRoutes } from "../creatives";
import { Routes as commonRoutes } from "../index";
import { Routes as pixelRoutes } from "../pixels";
import { Routes as reportRoutes } from "../report";

export const Routes = (flags = {}) => {
  const { whitelabelRoiPixelEnabled, whitelabelBrandLiftCampaign, whitelabelDoubleCreativeApproval } = flags;

  const routes = [
    {
      component: MarginsPage,
      path: "/admin/margins",
      title: ["Margin Controls"],
    },
    {
      component: MarginCreatePage,
      path: "/admin/margin/create",
      title: ["Margin Controls", "Create"],
    },
    {
      component: MarginEditPage,
      path: "/admin/margin/edit/:margin_id",
      title: ["Margin Controls", "Edit"],
    },
    {
      component: UsersPage,
      path: "/admin/users",
      title: ["Users"],
    },
    {
      component: UserCreatePage,
      path: "/admin/user/create",
      title: ["Users", "Create"],
    },
    {
      component: UserEditPage,
      path: "/admin/user/edit/:user_id",
      title: ["Users", "Edit"],
    },
    {
      component: AdminCreativesApprovalsPage,
      creativeType: CREATIVE_TYPES.onsite,
      path: "/admin/onsite-creatives",
      title: ["On-Site Creatives"],
    },
    {
      component: AdminCreativesApprovalsPage,
      creativeType: CREATIVE_TYPES.instoreDOOH,
      path: "/admin/in-store-dooh",
      title: ["In-store DOOH"],
    },
  ];

  if (whitelabelBrandLiftCampaign && whitelabelDoubleCreativeApproval) {
    routes.push({
      component: AdminCreativesApprovalsPage,
      creativeType: CREATIVE_TYPES.brandLift,
      path: "/admin/brand-lift-creatives",
      title: ["Brand Lift Creatives"],
    });
  }

  if (whitelabelRoiPixelEnabled) {
    routes.push(
      {
        component: ProductCatalogPermissionsPage,
        path: "/admin/product-catalog-permissions",
        title: ["Product Catalog Permissions"],
      },
      {
        component: ProductCatalogPermissionsCreatePage,
        path: "/admin/product-catalog-permissions/create",
        title: ["Product Catalog Permissions", "Create"],
      },
      {
        component: ProductCatalogPermissionsEditPage,
        path: "/admin/product-catalog-permissions/edit/:permissionId",
        title: ["Product Catalog Permissions", "Edit"],
      },
    );
  }

  return routes.concat(creativeRoutes(flags), pixelRoutes(flags), reportRoutes(flags), commonRoutes);
};
